import { createSlice } from '@reduxjs/toolkit';

const appSlice = createSlice({
  name: 'app',
  initialState: {},
  reducers: {
    displayToast: (state, action) => {
      return {
        ...state,
        toastMessage: action.payload,
      };
    },
    clearToast: (state) => {
      return {
        ...state,
        toastMessage: undefined,
      };
    },
    switchLocale: (state, action) => {
      const defaultLocale = 'en-US';
      const requestedLocale = action.payload;
      const currentLocale = state.locale;
      let locale = requestedLocale;
      if (!locale) {
        locale = currentLocale ? currentLocale : defaultLocale;
      }
      return {
        ...state,
        locale: locale,
      };
    },
  },
});

export default appSlice;
export const { displayToast, clearToast, switchLocale } = appSlice.actions;
